import React, { useState, useEffect } from 'react';
import { Typography, Paper, Box, Button, Alert } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Tenant = ({ currentTenant, placeDescription, token }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Check if user is logged in based on token
    setIsLoggedIn(!!token);
  }, [token]);

  // Default message for both WhatsApp and Messenger
  const defaultMessage = `Hello, I have a question about the rental at ${placeDescription || 'rentlord.online'}!`;

  // Format tenant phone number for WhatsApp (remove spaces, parentheses, dashes, etc.)
  const formatPhoneNumber = (phone) => {
    if (!phone) return null;
    // Remove all non-digit characters except the leading '+' for international format
    return phone.replace(/[^\d+]/g, '');
  };

  // WhatsApp link: Use tenant's phone number if available
  const tenantPhone = currentTenant ? formatPhoneNumber(currentTenant.tenant_phone) : null;
  const whatsappLink = tenantPhone ? `https://wa.me/${tenantPhone}?text=${encodeURIComponent(defaultMessage)}` : null;

  return (
    <Box sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h6" gutterBottom>
        Tenant
      </Typography>
      <Paper sx={{ p: 3, boxShadow: 3, borderRadius: 2 }}>
        {currentTenant ? (
          <Box>
            <Typography variant="body1"><strong>Name:</strong> {currentTenant.tenant_name}</Typography>
            <Typography variant="body1"><strong>Email:</strong> {currentTenant.tenant_email}</Typography>
            <Typography variant="body1"><strong>Phone:</strong> {currentTenant.tenant_phone}</Typography>
            <Typography variant="body1"><strong>Rent Amount:</strong> {currentTenant.rent_amount} {currentTenant.rent_currency}</Typography>
            <Typography variant="body1"><strong>Rent Start:</strong> {currentTenant.rent_start}</Typography>
            <Typography variant="body1"><strong>Rent End:</strong> {currentTenant.rent_end}</Typography>
            {isLoggedIn ? (
              <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                <Button
                  variant="contained"
                  color="success"
                  startIcon={<WhatsAppIcon />}
                  href={whatsappLink}
                  target="_blank"
                  sx={{ textTransform: 'none' }}
                  disabled={!whatsappLink}
                >
                  Send via WhatsApp
                </Button>
              </Box>
            ) : (
              <Alert severity="error" sx={{ mt: 2 }}>
                Please log in to send a message.
              </Alert>
            )}
            {!whatsappLink && currentTenant && isLoggedIn && (
              <Alert severity="warning" sx={{ mt: 2 }}>
                WhatsApp contact is unavailable due to missing or invalid tenant phone number.
              </Alert>
            )}
          </Box>
        ) : (
          <Typography variant="body1" color="textSecondary">
            No active tenant at this time.
          </Typography>
        )}
      </Paper>
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
    </Box>
  );
};

export default Tenant;